import Password from "./Password";
import SelfDisclosure from "./SelfDisclosure";
import SelfDisclosurePersisted from "./SelfDisclosurePersisted";
import PaySlip from "./PaySlip";
import Flatrate from "./Flatrate";

export default {
    PasswordStore: Password,
    SelfDisclosureStore: SelfDisclosure,
    SelfDisclosurePersistedStore: SelfDisclosurePersisted,
    PaySlipStore: PaySlip,
    FlatrateStore: Flatrate
};
